module.exports = __webpack_public_path__ + "static/media/Dr. Christian Herbert Ayiku.49a3b15f.png";